import Echo from "laravel-echo";
import Pusher from "pusher-js";

let echoInstance = null;

export function getEcho({ token }) {
    if (echoInstance) return echoInstance;

    window.Pusher = Pusher;
    Pusher.logToConsole = true;

    const key = process.env.REACT_APP_PUSHER_KEY || "crm-key";
    const cluster = process.env.REACT_APP_PUSHER_CLUSTER || "mt1";

    const wsHost = process.env.REACT_APP_PUSHER_HOST || window.location.hostname;
    const wsPort = Number(process.env.REACT_APP_PUSHER_PORT || 6001);
    const scheme =
        process.env.REACT_APP_PUSHER_SCHEME ||
        (window.location.protocol === "https:" ? "https" : "http");

    const apiBase = (process.env.REACT_APP_BASE_API_URL || "").replace(/\/+$/, "");

    const authEndpoint = `${apiBase}/broadcasting/auth`;

    echoInstance = new Echo({
        broadcaster: "pusher",
        key,
        cluster, // ✅ required by pusher-js

        wsHost,
        wsPort,
        wssPort: wsPort,
        forceTLS: scheme === "https",
        enabledTransports: ["ws", "wss"],
        disableStats: true,

        authEndpoint,
        auth: {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
        },
    });

    window.Echo = echoInstance;

    console.log("[Echo] init", { key, cluster, wsHost, wsPort, scheme, authEndpoint });

    return echoInstance;
}

export function resetEcho() {
    if (!echoInstance) return;
    try { echoInstance.disconnect(); } catch {}
    echoInstance = null;
}
